import { UpgradeRegistryItem } from '../upgrader.types'
/**
 * component 对应组件类型
 * form 从某个版本开始升级
 * to 升级到的版本
 * upgrade 升级方法，具体的值
 *  {
      from: 1,
      to: 2,
      upgrade(schema) {
        // 添加 autoFitHeight 属性，默认为 false
        // if (!('autoFitHeight' in schema.prop)) {
        //   schema.prop.autoFitHeight = false
        // }
        return schema
      }
    }
 */
export const formSelectUpgrades: UpgradeRegistryItem = {
  component: 'FormSelect',
  upgrades: [
    {
      from: 2,
      to: 3,
      upgrade(schema) {
        // 添加selectType属性（下拉类型：单选|多选）
        if (!('selectType' in schema.formProp)) {
          schema.formProp.selectType = 'single'
        }
        // 添加checkStrictly属性（父子节点不关联）
        if (!('checkStrictly' in schema.formProp)) {
          schema.formProp.checkStrictly = false
        }
        return schema
      }
    }
  ]
}
